// Define a function to disable add to cart button when price is "From HK$370.00"
var disableAddToCart = function() {
  if ($('.product__price span[data-product-price]').length > 0) {
    var displayedPrice = $('.product__price span[data-product-price]').attr('data-product-price');
    if (displayedPrice === 'From HK$370.00') {
      $('button.product-form__cart-submit').prop('disabled', true);
    } else {
      $('button.product-form__cart-submit').prop('disabled', false);
    }
  }
};

// Define a function to observe mutations to the product page and trigger the callback function
var observePriceChanges = function() {
  var targetNode = $('.product__price').get(0);
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      disableAddToCart();
    });
  });
  observer.observe(targetNode, { childList: true, subtree: true });
};